import React, { useState } from "react";
import { useNavigate, BrowserRouter as Router } from "react-router-dom";
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
import "./menubar.css";

const MenuBar = ({
  menuData,
  textColor = "#fff",
  bgColor = "#222",
  hoverColor = "#FFD700",
  dropdownBgColor = "#333",
  dropdownTextColor = "#fff",
  onMenuClick,
}) => {
  const [hovered, setHovered] = useState({ menu: null, subMenu: null, deepSubMenu: null });

  const navigate = useNavigate();

  // const handleNavigation = (path) => {
  //   if (path) navigate(path);
  // };

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
      if (onMenuClick) {
        onMenuClick(path);
      }
    }
  };

  const getColor = (type, name) =>
    hovered[type] === name ? hoverColor : type === "menu" ? textColor : dropdownTextColor;

  return (
    <nav className="menu-bar" style={{ backgroundColor: bgColor }}>
      <ul className="menu-list">
        {menuData.map((menu) => (
          <li
            key={menu.name}
            className="menu-item"
            style={{ color: getColor("menu", menu.name) }}
            onMouseEnter={() => setHovered({ ...hovered, menu: menu.name })}
            onMouseLeave={() => setHovered({ ...hovered, menu: null, subMenu: null, deepSubMenu: null })}
            onClick={() => handleNavigation(menu.path)}
          >
            <div className="menu-title">
              {menu.icon && <span className="menu-icon" style={{ color: getColor("menu", menu.name) }}>{menu.icon}</span>}
              {menu.name}
              {menu.subMenu && <FaAngleDown className="arrow" style={{ color: getColor("menu", menu.name) }} />}
            </div>

            {hovered.menu === menu.name && menu.subMenu && (
              <ul className="dropdown" style={{ backgroundColor: dropdownBgColor }}>
                {menu.subMenu.map((sub) => (
                  <li
                    key={sub.name}
                    className="submenu-item"
                    style={{ color: getColor("subMenu", sub.name) }}
                    onMouseEnter={() => setHovered({ ...hovered, subMenu: sub.name })}
                    onMouseLeave={() => setHovered({ ...hovered, subMenu: null, deepSubMenu: null })}
                    onClick={() => handleNavigation(sub.path)}
                  >
                    <div className="submenu-title">
                      {sub.icon && <span className="submenu-icon" style={{ color: getColor("subMenu", sub.name) }}>{sub.icon}</span>}
                      {sub.name}
                      {sub.subMenu && <FaAngleRight className="arrow-right" style={{ color: getColor("subMenu", sub.name) }} />}
                    </div>

                    {hovered.subMenu === sub.name && sub.subMenu && (
                      <ul className="sub-dropdown" style={{ backgroundColor: dropdownBgColor }}>
                        {sub.subMenu.map((deepSub) => (
                          <li
                            key={deepSub.name}
                            className="deep-submenu-item"
                            style={{ color: getColor("deepSubMenu", deepSub.name) }}
                            onMouseEnter={() => setHovered({ ...hovered, deepSubMenu: deepSub.name })}
                            onMouseLeave={() => setHovered({ ...hovered, deepSubMenu: null })}
                            onClick={() => handleNavigation(deepSub.path)}
                          >
                            {deepSub.icon && <span className="deep-submenu-icon" style={{ color: getColor("deepSubMenu", deepSub.name) }}>{deepSub.icon}</span>}
                            {deepSub.name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

// Ensure the component is always inside a Router
const WrappedMenuBar = (props) => (
  <Router>
    <MenuBar {...props} />
  </Router>
);

export default WrappedMenuBar;
